var _defs, _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgJavalogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0,0,256,256",
    width: "240px",
    height: "240px",
    fillRule: "nonzero",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: 22.677,
    y1: 21.174,
    x2: 30.737,
    y2: 43.318,
    gradientUnits: "userSpaceOnUse",
    id: "color-1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c65d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#464eb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 19.498,
    y1: 22.77,
    x2: 27.296,
    y2: 44.196,
    gradientUnits: "userSpaceOnUse",
    id: "color-2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c65d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#464eb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 18.698,
    y1: 23.455,
    x2: 26.59,
    y2: 45.14,
    gradientUnits: "userSpaceOnUse",
    id: "color-3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c65d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#464eb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 18.03,
    y1: 24.198,
    x2: 25.861,
    y2: 45.712,
    gradientUnits: "userSpaceOnUse",
    id: "color-4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c65d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#464eb0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: 20.725,
    y1: 24.582,
    x2: 28.228,
    y2: 45.197,
    gradientUnits: "userSpaceOnUse",
    id: "color-5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5c65d6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.999,
    stopColor: "#464eb0"
  })))), /*#__PURE__*/React.createElement("g", {
    transform: ""
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#ffffff",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0,256v-256h256v256z",
    id: "bgRectangle"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "nonzero",
    stroke: "none",
    strokeWidth: 1,
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    strokeMiterlimit: 10,
    strokeDasharray: "",
    strokeDashoffset: 0,
    fontFamily: "none",
    fontWeight: "none",
    fontSize: "none",
    textAnchor: "none",
    style: {
      mixBlendMode: "normal"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "scale(5.33333,5.33333)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.65,24.898c-0.998,-1.609 -1.722,-2.943 -2.725,-5.455c-1.696,-4.243 10.315,-8.077 5.445,-15.444c2.111,5.089 -7.577,8.235 -8.477,12.473c-0.823,3.898 5.752,8.426 5.757,8.426z",
    fill: "#d43a02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.878,17.27c-0.192,2.516 2.229,3.857 2.299,5.695c0.056,1.496 -1.447,2.743 -1.447,2.743c0,0 2.728,-0.536 3.579,-2.818c0.945,-2.534 -1.834,-4.269 -1.548,-6.298c0.267,-1.938 6.031,-5.543 6.031,-5.543c0,0 -8.481,0.562 -8.914,6.221z",
    fill: "#d43a02"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.084,25.055c1.754,-0.394 3.233,0.723 3.233,2.01c0,2.901 -4.021,5.643 -4.021,5.643c0,0 6.225,-0.742 6.225,-5.505c0,-3.15 -3.057,-3.937 -5.437,-2.148zM29.129,27.395c0,0 1.941,-1.383 2.458,-1.902c-4.763,1.011 -15.638,1.147 -15.638,0.269c0,-0.809 3.507,-1.638 3.507,-1.638c0,0 -7.773,-0.112 -7.773,2.181c0,2.39 10.175,2.561 17.446,1.09z",
    fill: "url(#color-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.935,29.571c-4.509,1.499 -12.814,1.02 -10.354,-0.993c-1.198,0 -2.974,0.963 -2.974,1.889c0,1.857 8.982,3.291 15.63,0.572z",
    fill: "url(#color-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.686,32.739c-1.636,0 -2.695,1.054 -2.695,1.822c0,2.391 9.76,2.632 13.627,0.205l-2.458,-1.632c-2.889,1.27 -10.146,1.445 -8.474,-0.395z",
    fill: "url(#color-3)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.281,36.632c0,-0.936 -1.055,-1.377 -1.433,-1.588c2.228,5.373 -22.317,4.956 -22.317,1.784c0,-0.721 1.807,-1.427 3.477,-1.093l-1.42,-0.839c-3.328,-0.522 -5.588,0.941 -5.588,2.121c0,5.503 27.281,5.238 27.281,-0.385z",
    fill: "url(#color-4)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39,38.604c-4.146,4.095 -14.659,5.587 -25.231,3.057c10.572,4.503 25.181,1.967 25.231,-3.057z",
    fill: "url(#color-5)"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJavalogo);
export default __webpack_public_path__ + "static/media/javalogo.b0ef09307968614e85c5ffee5dada442.svg";
export { ForwardRef as ReactComponent };